import React from 'react'
import { SVGIconProps } from '../types'
const SvgSyncAlt = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="m22 8-4-4v3H3v2h15v3zM2 16l4 4v-3h15v-2H6v-3z" />
  </svg>
)
export default SvgSyncAlt
